export default "__VITE_ASSET__9b97c68f__"